import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const usersClient = axios.create({
  baseURL: process.env.VUE_APP_USERS_URL,
  withCredentials: true,
});

usersClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(usersClient);

export default usersClient;
